export default __webpack_public_path__ + "static/media/chevron-left.88789ab8.svg";